module.exports = __webpack_public_path__ + "static/media/BalancoFinanc4.d4a7170d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelBalancoFinanc/BalancoFinanc4.png
// module id = 2173
// module chunks = 0